import { PaymentPlanHistoryItem } from '@frontend/api-payment-plans';
import { TableColumnConfig } from '@frontend/design-system';
import { formatCentsToCurrency } from '../../../utils/currency-helpers';
import { isoDateToDisplayAbbrString } from '../../../utils/date-helpers';
import { PaymentPlanInvoiceStatusChip } from '../PaymentPlanInvoiceStatusChip';

export const generateColumns: TableColumnConfig<PaymentPlanHistoryItem>[] = [
  {
    id: 'date',
    Header: 'Created Date',
    accessor: (paymentItem) => isoDateToDisplayAbbrString(paymentItem?.occurredAt || ''),
    disableSortBy: true,
  },
  {
    id: 'paymentDate',
    Header: 'Payment Date',
    accessor: (paymentItem) => {
      const paymentDate = paymentItem?.payment?.scheduledFor || paymentItem?.payment?.paidAt;
      const formattedDate = paymentDate ? isoDateToDisplayAbbrString(paymentDate) : '';
      return formattedDate;
    },
    disableSortBy: true,
  },
  {
    id: 'amount',
    Header: 'Amount',
    accessor: (paymentItem) => formatCentsToCurrency(paymentItem?.payment?.amount || 0),
    disableSortBy: true,
  },
  {
    id: 'status',
    Header: 'Payment status',
    accessor: (paymentItem) => <PaymentPlanInvoiceStatusChip paymentPlanInvoiceStatus={paymentItem?.payment?.status} />,
    disableSortBy: true,
  },
  {
    id: 'balance',
    Header: 'Balance',
    accessor: (paymentItem) => formatCentsToCurrency(paymentItem?.payment?.balanceRemaining || 0),
    disableSortBy: true,
  },
  {
    id: 'remaining',
    Header: 'Remaining',
    accessor: (paymentItem) => paymentItem?.payment?.remainingTerm,
    disableSortBy: true,
  },
];
